import { DateUtils } from "~app/common/utils/date-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { AtgardStatuses } from "~app/features/virkeskop/models/atgardstatus/atgardstatuses-models";
import { AvverkningsanmalanTyp } from "../../atgard-avverkningsanmalan/avverkningsanmalan-typ";
import { AtgardStatusBase, IAtgardStatus, IAtgardStatusIcon, IAtgardStatusTooltip } from "./atgardheadericons-models";

export class AvvAtgardStatus extends AtgardStatusBase implements IAtgardStatus {

    header = "Avverkningsanmälan";
    tooltips = this.getTooltips();
    icons: IAtgardStatusIcon[] = [
        {
            iconclass1: "fat fa-paper-plane",
            visible: true,
            incomplete: this.isIncomplete(),
            warning: this.isWarning()
        },
        {
            iconclass1: "ri ri-sveaskog",
            visible: this.isSveaskog(),
            incomplete: false,
            warning: false
        },
        {
            iconclass1: "fat fa-tree",
            visible: !this.isSveaskog(),
            incomplete: false,
            warning: false
        }
    ];
    private readonly avverkningsanmalanDaysWarning = 90;
    private readonly canHandleAnmalan: boolean;

    constructor(status: AtgardStatuses, canHandleAnmalan: boolean) {
        super(status);
        this.canHandleAnmalan = canHandleAnmalan;
    }

    visible(): boolean { return this.canHandleAnmalan === true && !ObjectUtils.isNullOrUndefined(this.status.avverkningsanmalan); }

    private isIncomplete(): boolean {
        return ObjectUtils.isNullOrUndefined(this.status.avverkningsanmalan.godkantDatum);
    }
    private isSveaskog(): boolean {
        return this.status.avverkningsanmalan.avverkningsanmalanTyp !== AvverkningsanmalanTyp.leverantor;
    }
    private isWarning(): boolean {
        const today = DateUtils.now();
        const daysDiff = DateUtils.daysBetween(this.status.avverkningsanmalan.giltigtTillDatum, today);
        return daysDiff <= this.avverkningsanmalanDaysWarning;
    }
    private getTooltips(): IAtgardStatusTooltip[] {
        const tooltips = [];
        tooltips.push({
            header: "Anmälan utförd",
            text: this.status.avverkningsanmalan.godkantDatum,
            visible: true
        });
        tooltips.push({
            header: "Avverkning får starta",
            text: this.status.avverkningsanmalan.farStartaDatum,
            visible: true
        });
        tooltips.push({
            header: "Giltig till",
            text: this.status.avverkningsanmalan.giltigtTillDatum,
            visible: true
        });
        tooltips.push({
            header: "Ansvarig",
            text: this.getAnsvarigLabel(),
            visible: true
        });
        return tooltips;
    }
    private getAnsvarigLabel(): string {
        return this.status.avverkningsanmalan.avverkningsanmalanTyp !== AvverkningsanmalanTyp.leverantor ? "Sveaskog" : "Leverantör";
    }
}
